export default "__VITE_ASSET__DJijRL4e__"